import Bugsnag from "@bugsnag/js";

import { DocumentLibrary, LibraryEntry } from "../model/library";

export const editorEntry = (state: DocumentLibrary): LibraryEntry | null => {
  const idx = state.editingEntry;

  if (idx === null) {
    return null;
  }

  if (idx < 0 || idx > state.entries.length) {
    Bugsnag.notify(
      `Library editor pointer set incorrectly. Length: ${state.entries.length}, index: ${idx}`
    );
    return null;
  }

  return state.entries[idx];
};
